module.exports = __webpack_public_path__ + "static/media/svg-2.87c0e995.svg";